var React = require('react');

function MenuHomeIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"#1E1E1E","fillRule":"evenodd","d":"M12.573 13.066c0 .119-.097.216-.215.216H9.97v-3.43c0-.893-.724-1.62-1.614-1.62H6.643c-.89 0-1.614.727-1.614 1.62v3.43H2.642c-.119 0-.215-.097-.215-.216V6.388l4.355-4.372c.191-.193.446-.299.718-.299.271 0 .526.106.718.299l4.355 4.372v6.678zm-3.886.216H6.313v-3.43c0-.182.148-.33.33-.33h1.714c.182 0 .33.148.33.33v3.43zm6.125-6.469l-5.686-5.71c-.897-.9-2.356-.9-3.252 0L.188 6.814c-.25.252-.25.66 0 .912.121.122.282.189.454.189.171 0 .333-.067.454-.189l.047-.047v5.388c0 .83.672 1.505 1.499 1.505h9.716c.826 0 1.499-.675 1.499-1.505V7.678l.047.047c.121.122.282.189.454.189.171 0 .333-.067.454-.189S15 7.441 15 7.27c0-.172-.067-.334-.188-.456z"}));
}

MenuHomeIcon.defaultProps = {"width":"15","height":"15","viewBox":"0 0 15 15"};

module.exports = MenuHomeIcon;

MenuHomeIcon.default = MenuHomeIcon;
